import { SubNavigation, SubNavigationLink } from '@apex/component-library'
import React from 'react'
import { Link as ReactRouterLink, useRouteMatch } from 'react-router-dom'
import { RoutesEnum } from '../../types/RoutesEnum'

const SubNavigationContainer = () => {
  const isTransferReview = !!useRouteMatch(`/${RoutesEnum.TransferReview}`)
  const isAccountTransfer = !!useRouteMatch(`/${RoutesEnum.InitiateTransfer}`)
  return (
    <SubNavigation>
      <SubNavigationLink
        data-testid="subnav-link"
        as={ReactRouterLink}
        to={`/${RoutesEnum.TransferReview}`}
        isCurrentPage={isTransferReview}
      >
        Account Transfer Review
      </SubNavigationLink>
      <SubNavigationLink
        data-testid="subnav-link"
        as={ReactRouterLink}
        to={`/${RoutesEnum.InitiateTransfer}`}
        isCurrentPage={isAccountTransfer}
      >
        Initiate Account Transfer
      </SubNavigationLink>
    </SubNavigation>
  )
}

export default SubNavigationContainer
